import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './App.css';
import ChatView from './pages/ChatView';
import Settings from './pages/Settings';
import Chats from './pages/Chats';

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Chats />} />
        <Route path="/chats" element={<Chats />} />
        <Route path="/chats/:username" element={<ChatView />} />
        <Route path="/settings/:username" element={<Settings />} />
        <Route path="/settings" element={<Settings />} />
      </Routes>
    </BrowserRouter>
  );
}
